import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  formControlItem: {
    width: '80%',
    marginLeft: '1%',
    border: `1px solid ${theme.palette.grey[400]}`,
    marginBottom: 8,
    borderRadius: 10,
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  root: {
    backgroundColor: theme.palette.grey[200],
    height: 94,
    borderRadius: 4,
    display: 'flex',
    justifyContent: 'center',
    transition: 'all 0.25s linear',
    position: 'relative',
    alignItems: 'center',
    cursor: 'pointer',
    // width: 229,
    textAlign: 'center'
  },
  active: {
    backgroundColor: theme.palette.grey[100],
    height: 94,
    border: `2px solid ${theme.palette.primary.main}`
  },
  activeCircle: {
    position: 'absolute',
    top: 10,
    left: 10,
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main
  }
}))

export default useStyles
